export { default as ICONS } from "./icons";

export const DEFAULT_COLUMN = {
  title: "",
  key: "",
  headerClassName: "",
  sortable: true, // Only Works with first level keys, not nested key
  editable: false, // Only Works with first level keys, not nested key
  addable: null, // field will be generated on add button click for this column, key
  render: null, // Optional function returns desired cell content
};

export const PAGINATE_SEPARATOR = "...";

export const SORT_ORDER = {
  ASC: "ASC",
  DESC: "DESC",
};
